import React, { useEffect, useState } from "react"
import game from "../assets/icons/logo.png"
import subscribe from "../assets/icons/subscribe.png"
import tick from "../assets/icons/tick.png"
import './Subscribe.scss'
import { reactLocalStorage } from 'reactjs-localstorage';
import config from "../config"
import Modal from 'react-modal';
import { useHistory } from "react-router-dom";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '80%'
    },
};

Modal.setAppElement('#root');


function Subscribe() {
    console.log('inside Subscribe container')
    const [modalIsOpen, setIsOpen] = useState(false);
    const [userPackmodal, setuserPackmodal] = useState(false);
    const [msg, setMsg] = useState('');
    const [status, setStatus] = useState('')
    const [userPacks, setUserPacks] = useState('')
    let history = useHistory();

    useEffect(() => {
        const url = `${config.get('base')}${config.get('userPacks')}`
        fetch(url,
            {
                method: 'POST',
                headers: config.get('headers')
            })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((res) => {
                reactLocalStorage.set(res.status,"success");
                if (res.status === 'success') {
                    console.log("res>>>>>>>>>", res.packs && res.packs[0])
                    setUserPacks(res.packs[0])
                } else {
                    setuserPackmodal(true)
                }
            }).catch((err) => {
                console.log(err)
                setuserPackmodal(true)
            })
    }, [])


    function openModal() {
        setIsOpen(true);
    }

    // function afterOpenModal() {
    //     // references are now sync'd and can be accessed.
    //     subtitle.style.color = '#f00';
    // }

    function closeModal() {
        setIsOpen(false);
    }


    const subscribeUser = () => {
        reactLocalStorage.set("previousPage", 'subscripttion');
        const url = `${config.get('base')}${config.get('requestOTP')}`
        fetch(url, {
            method: 'POST',
            body: JSON.stringify({'msisdn': reactLocalStorage.get("msisdn")}),
            headers:config.get('headers')  
            })
            .then(res => {
                if (!res.ok) { throw res }
                return res.json()
            })
            .then((result) => {
                console.log('result message::', result)
                if(result.status === 'success'){
                    history.push('/otp')
                }else{
                    setMsg(result.message)
                    setIsOpen(true)
                    setStatus(result.status)
                }
            },
            (error) => {
                console.log('error:::', error)
                // setMessage(error)
            })
        }
        
    //     const url = `${config.get('base')}${config.get('subscribe')}`
    //     fetch(url, {
    //         method: 'POST',
    //         body: JSON.stringify({ 'msisdn': reactLocalStorage.get("msisdn") }),
    //         headers: config.get('headers')
    //     })
    //         .then(res => {
    //             if (!res.ok) { throw res }
    //             return res.json()
    //         })
    //         .then((result) => {
    //             console.log('result message::', result)
    //             setMsg(result.message)
    //             setStatus(result.status)
    //             openModal()
    //         },
    //             (error) => {
    //                 console.log('error:::', error)
    //             })
    // }

    const handleClick = () => {
        // if (status === 'failed') {
            if (status === 'failed') {
            history.push("/home");
        } else {
            window.open(reactLocalStorage.get("gameUrl"), "_self")
        }
    }

    return (
        <div className="container m-w">
            <Modal
                isOpen={userPackmodal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div>Dear User, There is some connectivity issue as of now, We will get back to you very soon, Kindly try after sometime.</div>
                <button
                    onClick={() => history.push("/home")}
                    style={{
                        width: '23%',
                        backgroundColor: 'rgb(23 54 206)',
                        color: 'white',
                        padding: '4% 1%',
                        margin: '8px 0',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                >Okay</button>
            </Modal>
            <Modal
                isOpen={modalIsOpen}
                // onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <div>{msg}</div>
                <button
                    style={{
                        width: '23%',
                        backgroundColor: 'rgb(23 54 206)',
                        color: 'white',
                        padding: '4% 1%',
                        margin: '8px 0',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontWeight: 'bold'
                    }}
                    onClick={handleClick}>{status === 'failed' ? 'Okay' : 'Proceed'}</button>
                    
            </Modal>
            <div className="columns is-mobile">
                <div className="column is-full">
                    <div className="card">
                        <div className="card-content">
                            {/* <figure className="image z-s m-1">
                                <img src={zain} alt="zain logo" />
                            </figure> */}
                            <figure className="image l-s m-2">
                                <img src={game} alt="game logo" />
                            </figure>
                            <figure className="image s-s m-5 pb-5">
                                <img src={subscribe} alt="subcribe icon" />
                            </figure>
                            <div className="columns is-mobile is-multiline">
                                <div className="column is-full v-center p-2">
                                    <span>{userPacks && userPacks.amount + " " + userPacks.currency + "/" + userPacks.packKey}</span>
                                    <div className="button is-rounded btn-main ml-3" onClick={subscribeUser}>{userPacks && userPacks.button}</div>
                                </div>
                            </div>
                            <div className="columns is-mobile is-multiline mb-0">
                                <div className="column is-full">
                                    <p><img src={tick} alt="tick" className="f-w mr-1" />
                                        {userPacks && userPacks.subtitle[0]}</p>
                                    <p><img src={tick} alt="tick" className="f-w mr-1" />
                                        {userPacks && userPacks.subtitle[1]}</p>
                                    <p><img src={tick} alt="tick" className="f-w mr-1" />
                                        {userPacks && userPacks.subtitle[2]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Subscribe